<div
    class="svg-icon"
    [ngClass]="{'svg-icon__cursor-pointer': hoverColor}"
>
    <div class="svg-icon__overlay" (mouseenter)="mouseEntered()" (mouseleave)="mouserLeaved()"></div>
    <div
        class="svg-icon__icon"
        [ngClass]="{'svg-icon_rotate-45': rotate45}"
        #iconParentEl
        [innerHTML]="svg"
    ></div>
</div>
